export default __webpack_public_path__ + "static/media/hero.3ae72da7.jpg";